import type { ProgramEventContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import type { ProgramEventLayoutQueryData } from '../../queries';
import { ProgramEventLayoutSkeleton } from '../program-event-layout-skeleton';
import { RedirectToEventDetail } from '../redirect-to-event-detail';

type P = {
  children: (event: ProgramEventContentObjectDetail) => ReactNode;
  event: ProgramEventLayoutQueryData;
  header: (event: ProgramEventContentObjectDetail) => ReactNode;
  redirectToEventDetail: (id: string) => Promise<void>;
};

const ProgramEventLayoutWrapper = ({ children, event, header, redirectToEventDetail }: P) => {
  if ('nodeId' in event) {
    return (
      <>
        <RedirectToEventDetail eventId={event.nodeId} redirectToEventDetail={redirectToEventDetail} />
        <ProgramEventLayoutSkeleton />
      </>
    );
  }

  return (
    <>
      {header(event)}
      {children(event)}
    </>
  );
};

export default ProgramEventLayoutWrapper;
